import { render, staticRenderFns } from "./DeleteCouponRuleCpps.vue?vue&type=template&id=625d4b5d&scoped=true"
import script from "./DeleteCouponRuleCpps.vue?vue&type=script&lang=js"
export * from "./DeleteCouponRuleCpps.vue?vue&type=script&lang=js"
import style0 from "./DeleteCouponRuleCpps.vue?vue&type=style&index=0&id=625d4b5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625d4b5d",
  null
  
)

export default component.exports